import { useState } from "react";
import Sidebar from "./sidebar";
import Header from "./header";
import { DataProvider } from "../Context";

const Layout = ({ userData, userId, setUserInfo, children, setIsLoggedIn }) => {
    const [isCollapsed, setIsCollapsed] = useState(true);
    return (
        <div>
            <DataProvider userId={userId}>
                <div className=" fixed top-0 left-0 z-50 w-full">
                    <Header
                        userInfo={userData}
                        userId={userId}
                        setUserInfo={setUserInfo}
                        setIsLoggedIn={setIsLoggedIn}
                    />
                </div>
                <div className="flex h-screen">
                    <Sidebar isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
                    <div
                        className="mt-[60px] h-[calc(100vh-60px)] overflow-auto transition-all duration-300 w-full"
                        style={{ marginLeft: isCollapsed ? "60px" : "20%" }}
                    >
                        <div className="relative z-10">
                            {children}
                        </div>
                    </div>
                </div>
            </DataProvider>
        </div>
    );
};

export default Layout;
